/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Rbac_TitleInputs */

const en_landing_features_rbac_title = /** @type {(inputs: Landing_Features_Rbac_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Roles & Permissions`)
};

const zh_landing_features_rbac_title = /** @type {(inputs: Landing_Features_Rbac_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`角色与权限`)
};

/**
* | output |
* | --- |
* | "Roles & Permissions" |
*
* @param {Landing_Features_Rbac_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_rbac_title = /** @type {((inputs?: Landing_Features_Rbac_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Rbac_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_rbac_title(inputs)
	return zh_landing_features_rbac_title(inputs)
});
export { landing_features_rbac_title as "landing.features.rbac.title" }